export default __webpack_public_path__ + "static/media/cloud_upload.900b9229.svg";